export const findDifferentField = (firstDict, secondDict) => {
  const entry = Object.entries(firstDict).find(([key, value]) => secondDict[key] !== value);

  if (!entry) {
    return null;
  }

  const [fieldName, fieldValue] = entry;

  return { fieldName, value: fieldValue };
};
